import { render, staticRenderFns } from "./TaxReturn.vue?vue&type=template&id=48809098&"
import script from "./TaxReturn.vue?vue&type=script&lang=js&"
export * from "./TaxReturn.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports